export const ACCOUNT_TYPES = [
  { label: "فرد", value: "individual" },
  { label: "شركة صغيرة", value: "small-company" },
  { label: "مركز بحثي", value: "research-center" },
];

export const ENTITY_TYPES = [
  { label: "شركة استشارية", value: "consulting" },
  { label: "جهة حكومية", value: "governmental" },
  { label: "منظمة غير ربحية", value: "non-profit" },
  { label: "أخرى", value: "other" },
];

export const WAFRA_FIELD = [
  { label: "التمكين الاجتماعي والاقتصادي", value: "دراسات" },
  { label: "التنمية الاجتماعية", value: "تحليلات" },
  { label: "التعليم وتنمية القدرات", value: "تخطيط" },
  { label: "الصحة العامة والرعاية", value: "محتوى" },
  { label: "الاستدامة والبيئة", value: "أخرى" },
  { label: "القطاع غير الربحي والعمل الخيري", value: "أخرى" },
  { label: "السياسات العامة", value: "أخرى" },
  { label: "التحول الرقمي والتقنية", value: "أخرى" },
  { label: "المحتوى العلمي والإنتاج المعرفي", value: "أخرى" },
  { label: "التنمية الاقتصادية والاستثمار الاجتماعي", value: "أخرى" },
  { label: "الإعلام التنموي والمعرفي", value: "أخرى" },
];

export const COUNTRIES = [
  { value: 'AF', label: 'أفغانستان' },
  { value: 'AL', label: 'ألبانيا' },
  { value: 'DZ', label: 'الجزائر' },
  { value: 'AD', label: 'أندورا' },
  { value: 'AO', label: 'أنغولا' },
  { value: 'AG', label: 'أنتيغوا وبربودا' },
  { value: 'AR', label: 'الأرجنتين' },
  { value: 'AM', label: 'أرمينيا' },
  { value: 'AU', label: 'أستراليا' },
  { value: 'AT', label: 'النمسا' },
  { value: 'AZ', label: 'أذربيجان' },
  { value: 'BS', label: 'جزر البهاما' },
  { value: 'BH', label: 'البحرين' },
  { value: 'BD', label: 'بنغلاديش' },
  { value: 'BB', label: 'بربادوس' },
  { value: 'BY', label: 'بيلاروس' },
  { value: 'BE', label: 'بلجيكا' },
  { value: 'BZ', label: 'بليز' },
  { value: 'BJ', label: 'بنين' },
  { value: 'BT', label: 'بوتان' },
  { value: 'BO', label: 'بوليفيا' },
  { value: 'BA', label: 'البوسنة والهرسك' },
  { value: 'BW', label: 'بوتسوانا' },
  { value: 'BR', label: 'البرازيل' },
  { value: 'BN', label: 'بروناي' },
  { value: 'BG', label: 'بلغاريا' },
  { value: 'BF', label: 'بوركينا فاسو' },
  { value: 'BI', label: 'بوروندي' },
  { value: 'KH', label: 'كمبوديا' },
  { value: 'CM', label: 'الكاميرون' },
  { value: 'CA', label: 'كندا' },
  { value: 'CV', label: 'الرأس الأخضر' },
  { value: 'CF', label: 'جمهورية أفريقيا الوسطى' },
  { value: 'TD', label: 'تشاد' },
  { value: 'CL', label: 'تشيلي' },
  { value: 'CN', label: 'الصين' },
  { value: 'CO', label: 'كولومبيا' },
  { value: 'KM', label: 'جزر القمر' },
  { value: 'CG', label: 'الكونغو' },
  { value: 'CD', label: 'الكونغو الديمقراطية' },
  { value: 'CR', label: 'كوستاريكا' },
  { value: 'CI', label: 'ساحل العاج' },
  { value: 'HR', label: 'كرواتيا' },
  { value: 'CU', label: 'كوبا' },
  { value: 'CY', label: 'قبرص' },
  { value: 'CZ', label: 'التشيك' },
  { value: 'DK', label: 'الدنمارك' },
  { value: 'DJ', label: 'جيبوتي' },
  { value: 'DM', label: 'دومينيكا' },
  { value: 'DO', label: 'جمهورية الدومينيكان' },
  { value: 'EC', label: 'الإكوادور' },
  { value: 'EG', label: 'مصر' },
  { value: 'SV', label: 'السلفادور' },
  { value: 'GQ', label: 'غينيا الاستوائية' },
  { value: 'ER', label: 'إريتريا' },
  { value: 'EE', label: 'إستونيا' },
  { value: 'SZ', label: 'إسواتيني' },
  { value: 'ET', label: 'إثيوبيا' },
  { value: 'FJ', label: 'فيجي' },
  { value: 'FI', label: 'فنلندا' },
  { value: 'FR', label: 'فرنسا' },
  { value: 'GA', label: 'الغابون' },
  { value: 'GM', label: 'غامبيا' },
  { value: 'GE', label: 'جورجيا' },
  { value: 'DE', label: 'ألمانيا' },
  { value: 'GH', label: 'غانا' },
  { value: 'GR', label: 'اليونان' },
  { value: 'GD', label: 'غرينادا' },
  { value: 'GT', label: 'غواتيمالا' },
  { value: 'GN', label: 'غينيا' },
  { value: 'GW', label: 'غينيا بيساو' },
  { value: 'GY', label: 'غيانا' },
  { value: 'HT', label: 'هايتي' },
  { value: 'HN', label: 'هندوراس' },
  { value: 'HU', label: 'المجر' },
  { value: 'IS', label: 'آيسلندا' },
  { value: 'IN', label: 'الهند' },
  { value: 'ID', label: 'إندونيسيا' },
  { value: 'IR', label: 'إيران' },
  { value: 'IQ', label: 'العراق' },
  { value: 'IE', label: 'أيرلندا' },
  { value: 'IL', label: 'إسرائيل' },
  { value: 'IT', label: 'إيطاليا' },
  { value: 'JM', label: 'جامايكا' },
  { value: 'JP', label: 'اليابان' },
  { value: 'JO', label: 'الأردن' },
  { value: 'KZ', label: 'كازاخستان' },
  { value: 'KE', label: 'كينيا' },
  { value: 'KI', label: 'كيريباتي' },
  { value: 'KW', label: 'الكويت' },
  { value: 'KG', label: 'قرغيزستان' },
  { value: 'LA', label: 'لاوس' },
  { value: 'LV', label: 'لاتفيا' },
  { value: 'LB', label: 'لبنان' },
  { value: 'LS', label: 'ليسوتو' },
  { value: 'LR', label: 'ليبيريا' },
  { value: 'LY', label: 'ليبيا' },
  { value: 'LI', label: 'ليختنشتاين' },
  { value: 'LT', label: 'ليتوانيا' },
  { value: 'LU', label: 'لوكسمبورغ' },
  { value: 'MG', label: 'مدغشقر' },
  { value: 'MW', label: 'مالاوي' },
  { value: 'MY', label: 'ماليزيا' },
  { value: 'MV', label: 'المالديف' },
  { value: 'ML', label: 'مالي' },
  { value: 'MT', label: 'مالطا' },
  { value: 'MH', label: 'جزر مارشال' },
  { value: 'MR', label: 'موريتانيا' },
  { value: 'MU', label: 'موريشيوس' },
  { value: 'MX', label: 'المكسيك' },
  { value: 'FM', label: 'ميكرونيزيا' },
  { value: 'MD', label: 'مولدوفا' },
  { value: 'MC', label: 'موناكو' },
  { value: 'MN', label: 'منغوليا' },
  { value: 'ME', label: 'الجبل الأسود' },
  { value: 'MA', label: 'المغرب' },
  { value: 'MZ', label: 'موزمبيق' },
  { value: 'MM', label: 'ميانمار' },
  { value: 'NA', label: 'ناميبيا' },
  { value: 'NR', label: 'ناورو' },
  { value: 'NP', label: 'نيبال' },
  { value: 'NL', label: 'هولندا' },
  { value: 'NZ', label: 'نيوزيلندا' },
  { value: 'NI', label: 'نيكاراغوا' },
  { value: 'NE', label: 'النيجر' },
  { value: 'NG', label: 'نيجيريا' },
  { value: 'KP', label: 'كوريا الشمالية' },
  { value: 'NO', label: 'النرويج' },
  { value: 'OM', label: 'عُمان' },
  { value: 'PK', label: 'باكستان' },
  { value: 'PW', label: 'بالاو' },
  { value: 'PA', label: 'بنما' },
  { value: 'PG', label: 'بابوا غينيا الجديدة' },
  { value: 'PY', label: 'باراغواي' },
  { value: 'PE', label: 'بيرو' },
  { value: 'PH', label: 'الفلبين' },
  { value: 'PL', label: 'بولندا' },
  { value: 'PT', label: 'البرتغال' },
  { value: 'QA', label: 'قطر' },
  { value: 'RO', label: 'رومانيا' },
  { value: 'RU', label: 'روسيا' },
  { value: 'RW', label: 'رواندا' },
  { value: 'KN', label: 'سانت كيتس ونيفيس' },
  { value: 'LC', label: 'سانت لوسيا' },
  { value: 'VC', label: 'سانت فنسنت وجزر غرينادين' },
  { value: 'WS', label: 'ساموا' },
  { value: 'SM', label: 'سان مارينو' },
  { value: 'ST', label: 'ساو تومي وبرينسيبي' },
  { value: 'SA', label: 'السعودية' },
  { value: 'SN', label: 'السنغال' },
  { value: 'RS', label: 'صربيا' },
  { value: 'SC', label: 'سيشل' },
  { value: 'SL', label: 'سيراليون' },
  { value: 'SG', label: 'سنغافورة' },
  { value: 'SK', label: 'سلوفاكيا' },
  { value: 'SI', label: 'سلوفينيا' },
  { value: 'SB', label: 'جزر سليمان' },
  { value: 'SO', label: 'الصومال' },
  { value: 'ZA', label: 'جنوب أفريقيا' },
  { value: 'KR', label: 'كوريا الجنوبية' },
  { value: 'SS', label: 'جنوب السودان' },
  { value: 'ES', label: 'إسبانيا' },
  { value: 'LK', label: 'سريلانكا' },
  { value: 'SD', label: 'السودان' },
  { value: 'SR', label: 'سورينام' },
  { value: 'SE', label: 'السويد' },
  { value: 'CH', label: 'سويسرا' },
  { value: 'SY', label: 'سوريا' },
  { value: 'TJ', label: 'طاجيكستان' },
  { value: 'TZ', label: 'تنزانيا' },
  { value: 'TH', label: 'تايلاند' },
  { value: 'TL', label: 'تيمور الشرقية' },
  { value: 'TG', label: 'توغو' },
  { value: 'TO', label: 'تونغا' },
  { value: 'TT', label: 'ترينيداد وتوباغو' },
  { value: 'TN', label: 'تونس' },
  { value: 'TR', label: 'تركيا' },
  { value: 'TM', label: 'تركمانستان' },
  { value: 'TV', label: 'توفالو' },
  { value: 'UG', label: 'أوغندا' },
  { value: 'UA', label: 'أوكرانيا' },
  { value: 'AE', label: 'الإمارات' },
  { value: 'GB', label: 'المملكة المتحدة' },
  { value: 'US', label: 'الولايات المتحدة' },
  { value: 'UY', label: 'أوروغواي' },
  { value: 'UZ', label: 'أوزبكستان' },
  { value: 'VU', label: 'فانواتو' },
  { value: 'VA', label: 'الفاتيكان' },
  { value: 'VE', label: 'فنزويلا' },
  { value: 'VN', label: 'فيتنام' },
  { value: 'YE', label: 'اليمن' },
  { value: 'ZM', label: 'زامبيا' },
  { value: 'ZW', label: 'زيمبابوي' }
];

export const COUNTRIES_AR = [
  { value: 'AF', label: 'أفغانستان' },
  { value: 'AL', label: 'ألبانيا' },
  { value: 'DZ', label: 'الجزائر' },
  { value: 'AD', label: 'أندورا' },
  { value: 'AO', label: 'أنغولا' },
  { value: 'AG', label: 'أنتيغوا وبربودا' },
  { value: 'AR', label: 'الأرجنتين' },
  { value: 'AM', label: 'أرمينيا' },
  { value: 'AU', label: 'أستراليا' },
  { value: 'AT', label: 'النمسا' },
  { value: 'AZ', label: 'أذربيجان' },
  { value: 'BS', label: 'جزر البهاما' },
  { value: 'BH', label: 'البحرين' },
  { value: 'BD', label: 'بنغلاديش' },
  { value: 'BB', label: 'بربادوس' },
  { value: 'BY', label: 'بيلاروس' },
  { value: 'BE', label: 'بلجيكا' },
  { value: 'BZ', label: 'بليز' },
  { value: 'BJ', label: 'بنين' },
  { value: 'BT', label: 'بوتان' },
  { value: 'BO', label: 'بوليفيا' },
  { value: 'BA', label: 'البوسنة والهرسك' },
  { value: 'BW', label: 'بوتسوانا' },
  { value: 'BR', label: 'البرازيل' },
  { value: 'BN', label: 'بروناي' },
  { value: 'BG', label: 'بلغاريا' },
  { value: 'BF', label: 'بوركينا فاسو' },
  { value: 'BI', label: 'بوروندي' },
  { value: 'KH', label: 'كمبوديا' },
  { value: 'CM', label: 'الكاميرون' },
  { value: 'CA', label: 'كندا' },
  { value: 'CV', label: 'الرأس الأخضر' },
  { value: 'CF', label: 'جمهورية أفريقيا الوسطى' },
  { value: 'TD', label: 'تشاد' },
  { value: 'CL', label: 'تشيلي' },
  { value: 'CN', label: 'الصين' },
  { value: 'CO', label: 'كولومبيا' },
  { value: 'KM', label: 'جزر القمر' },
  { value: 'CG', label: 'الكونغو' },
  { value: 'CD', label: 'الكونغو الديمقراطية' },
  { value: 'CR', label: 'كوستاريكا' },
  { value: 'CI', label: 'ساحل العاج' },
  { value: 'HR', label: 'كرواتيا' },
  { value: 'CU', label: 'كوبا' },
  { value: 'CY', label: 'قبرص' },
  { value: 'CZ', label: 'التشيك' },
  { value: 'DK', label: 'الدنمارك' },
  { value: 'DJ', label: 'جيبوتي' },
  { value: 'DM', label: 'دومينيكا' },
  { value: 'DO', label: 'جمهورية الدومينيكان' },
  { value: 'EC', label: 'الإكوادور' },
  { value: 'EG', label: 'مصر' },
  { value: 'SV', label: 'السلفادور' },
  { value: 'GQ', label: 'غينيا الاستوائية' },
  { value: 'ER', label: 'إريتريا' },
  { value: 'EE', label: 'إستونيا' },
  { value: 'SZ', label: 'إسواتيني' },
  { value: 'ET', label: 'إثيوبيا' },
  { value: 'FJ', label: 'فيجي' },
  { value: 'FI', label: 'فنلندا' },
  { value: 'FR', label: 'فرنسا' },
  { value: 'GA', label: 'الغابون' },
  { value: 'GM', label: 'غامبيا' },
  { value: 'GE', label: 'جورجيا' },
  { value: 'DE', label: 'ألمانيا' },
  { value: 'GH', label: 'غانا' },
  { value: 'GR', label: 'اليونان' },
  { value: 'GD', label: 'غرينادا' },
  { value: 'GT', label: 'غواتيمالا' },
  { value: 'GN', label: 'غينيا' },
  { value: 'GW', label: 'غينيا بيساو' },
  { value: 'GY', label: 'غيانا' },
  { value: 'HT', label: 'هايتي' },
  { value: 'HN', label: 'هندوراس' },
  { value: 'HU', label: 'المجر' },
  { value: 'IS', label: 'آيسلندا' },
  { value: 'IN', label: 'الهند' },
  { value: 'ID', label: 'إندونيسيا' },
  { value: 'IR', label: 'إيران' },
  { value: 'IQ', label: 'العراق' },
  { value: 'IE', label: 'أيرلندا' },
  { value: 'IL', label: 'إسرائيل' },
  { value: 'IT', label: 'إيطاليا' },
  { value: 'JM', label: 'جامايكا' },
  { value: 'JP', label: 'اليابان' },
  { value: 'JO', label: 'الأردن' },
  { value: 'KZ', label: 'كازاخستان' },
  { value: 'KE', label: 'كينيا' },
  { value: 'KI', label: 'كيريباتي' },
  { value: 'KW', label: 'الكويت' },
  { value: 'KG', label: 'قرغيزستان' },
  { value: 'LA', label: 'لاوس' },
  { value: 'LV', label: 'لاتفيا' },
  { value: 'LB', label: 'لبنان' },
  { value: 'LS', label: 'ليسوتو' },
  { value: 'LR', label: 'ليبيريا' },
  { value: 'LY', label: 'ليبيا' },
  { value: 'LI', label: 'ليختنشتاين' },
  { value: 'LT', label: 'ليتوانيا' },
  { value: 'LU', label: 'لوكسمبورغ' },
  { value: 'MG', label: 'مدغشقر' },
  { value: 'MW', label: 'مالاوي' },
  { value: 'MY', label: 'ماليزيا' },
  { value: 'MV', label: 'المالديف' },
  { value: 'ML', label: 'مالي' },
  { value: 'MT', label: 'مالطا' },
  { value: 'MH', label: 'جزر مارشال' },
  { value: 'MR', label: 'موريتانيا' },
  { value: 'MU', label: 'موريشيوس' },
  { value: 'MX', label: 'المكسيك' },
  { value: 'FM', label: 'ميكرونيزيا' },
  { value: 'MD', label: 'مولدوفا' },
  { value: 'MC', label: 'موناكو' },
  { value: 'MN', label: 'منغوليا' },
  { value: 'ME', label: 'الجبل الأسود' },
  { value: 'MA', label: 'المغرب' },
  { value: 'MZ', label: 'موزمبيق' },
  { value: 'MM', label: 'ميانمار' },
  { value: 'NA', label: 'ناميبيا' },
  { value: 'NR', label: 'ناورو' },
  { value: 'NP', label: 'نيبال' },
  { value: 'NL', label: 'هولندا' },
  { value: 'NZ', label: 'نيوزيلندا' },
  { value: 'NI', label: 'نيكاراغوا' },
  { value: 'NE', label: 'النيجر' },
  { value: 'NG', label: 'نيجيريا' },
  { value: 'KP', label: 'كوريا الشمالية' },
  { value: 'NO', label: 'النرويج' },
  { value: 'OM', label: 'عُمان' },
  { value: 'PK', label: 'باكستان' },
  { value: 'PW', label: 'بالاو' },
  { value: 'PA', label: 'بنما' },
  { value: 'PG', label: 'بابوا غينيا الجديدة' },
  { value: 'PY', label: 'باراغواي' },
  { value: 'PE', label: 'بيرو' },
  { value: 'PH', label: 'الفلبين' },
  { value: 'PL', label: 'بولندا' },
  { value: 'PT', label: 'البرتغال' },
  { value: 'QA', label: 'قطر' },
  { value: 'RO', label: 'رومانيا' },
  { value: 'RU', label: 'روسيا' },
  { value: 'RW', label: 'رواندا' },
  { value: 'KN', label: 'سانت كيتس ونيفيس' },
  { value: 'LC', label: 'سانت لوسيا' },
  { value: 'VC', label: 'سانت فنسنت وجزر غرينادين' },
  { value: 'WS', label: 'ساموا' },
  { value: 'SM', label: 'سان مارينو' },
  { value: 'ST', label: 'ساو تومي وبرينسيبي' },
  { value: 'SA', label: 'السعودية' },
  { value: 'SN', label: 'السنغال' },
  { value: 'RS', label: 'صربيا' },
  { value: 'SC', label: 'سيشل' },
  { value: 'SL', label: 'سيراليون' },
  { value: 'SG', label: 'سنغافورة' },
  { value: 'SK', label: 'سلوفاكيا' },
  { value: 'SI', label: 'سلوفينيا' },
  { value: 'SB', label: 'جزر سليمان' },
  { value: 'SO', label: 'الصومال' },
  { value: 'ZA', label: 'جنوب أفريقيا' },
  { value: 'KR', label: 'كوريا الجنوبية' },
  { value: 'SS', label: 'جنوب السودان' },
  { value: 'ES', label: 'إسبانيا' },
  { value: 'LK', label: 'سريلانكا' },
  { value: 'SD', label: 'السودان' },
  { value: 'SR', label: 'سورينام' },
  { value: 'SE', label: 'السويد' },
  { value: 'CH', label: 'سويسرا' },
  { value: 'SY', label: 'سوريا' },
  { value: 'TJ', label: 'طاجيكستان' },
  { value: 'TZ', label: 'تنزانيا' },
  { value: 'TH', label: 'تايلاند' },
  { value: 'TL', label: 'تيمور الشرقية' },
  { value: 'TG', label: 'توغو' },
  { value: 'TO', label: 'تونغا' },
  { value: 'TT', label: 'ترينيداد وتوباغو' },
  { value: 'TN', label: 'تونس' },
  { value: 'TR', label: 'تركيا' },
  { value: 'TM', label: 'تركمانستان' },
  { value: 'TV', label: 'توفالو' },
  { value: 'UG', label: 'أوغندا' },
  { value: 'UA', label: 'أوكرانيا' },
  { value: 'AE', label: 'الإمارات' },
  { value: 'GB', label: 'المملكة المتحدة' },
  { value: 'US', label: 'الولايات المتحدة' },
  { value: 'UY', label: 'أوروغواي' },
  { value: 'UZ', label: 'أوزبكستان' },
  { value: 'VU', label: 'فانواتو' },
  { value: 'VA', label: 'الفاتيكان' },
  { value: 'VE', label: 'فنزويلا' },
  { value: 'VN', label: 'فيتنام' },
  { value: 'YE', label: 'اليمن' },
  { value: 'ZM', label: 'زامبيا' },
  { value: 'ZW', label: 'زيمبابوي' }
];

export const COUNTRIES_EN = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Democratic Republic of Congo' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: 'Ivory Coast' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GR', label: 'Greece' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'KP', label: 'North Korea' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];

export const COUNTRIES_COMBINED = COUNTRIES_AR.map(arItem => {
  const enItem = COUNTRIES_EN.find(e => e.value === arItem.value);
  return {
    value: arItem.value,
    labelAr: arItem.label,            
    labelEn: enItem?.label || "",
  };
});

export const EGYPT = [
  {
    value: 'EG',
    labelAr: 'مصر',
    labelEn: 'Egypt',
  },
];

export const LANGUAGES = [
  { value: 'Arabic', label: 'arabic' },
  { value: 'English', label: 'english' },
  { value: 'Both', label: 'both' },
];

export const PRICE_RANGES = [
  { label: '25 - 50', value: '25-50' },
  { label: '50 - 100', value: '50-100' },
  { label: '100 - 250', value: '100-250' },
  { label: '250 - 500', value: '250-500' },
  { label: '500 - 1000', value: '500-1000' },
  { label: '1000 - 2500', value: '1000-2500' },
  { label: '2500 - 5000', value: '2500-5000' },
  { label: '5000 - 10000', value: '5000-10000' },
];

export const LIMIT = 10;

export const PROCESSING_FEE_RATE = 0.03;
export const MIN_PROCESSING_FEE = 2;